var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 164.226,
    height: 215.434,
    viewBox: "0 0 164.226 215.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.094,
    x2: 0.631,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f3061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82140"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(916.212 -496.406)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-878.489,703.355q-18.336-8.478-27.724-22.421a56.572,56.572,0,0,1-10-30v-.606a5.156,5.156,0,0,1,1.969-4.09,6.647,6.647,0,0,1,4.394-1.666h28.785q6.966,0,8.787,6.059,4.239,13.338,14.089,19.7t23.18,6.363q16.965,0,28.027-10.3t11.06-28.481q0-16.362-11.06-26.513t-28.027-10.151q-9.09,0-14.847,2.424a49.848,49.848,0,0,0-11.211,6.666,29.1,29.1,0,0,0-2.727,1.818,16.3,16.3,0,0,1-3.788,2.121,10.052,10.052,0,0,1-3.484.606h-28.482a6.394,6.394,0,0,1-4.7-1.969,6.4,6.4,0,0,1-1.969-4.7l10.3-103.322a8.8,8.8,0,0,1,2.878-6.211,9.057,9.057,0,0,1,6.212-2.274h113.928a7.179,7.179,0,0,1,5.3,1.969,7.177,7.177,0,0,1,1.97,5.3v20.605a7.292,7.292,0,0,1-1.97,5.151,6.885,6.885,0,0,1-5.3,2.121H-860.46l-4.848,49.086a65.371,65.371,0,0,1,16.058-7.424q9.091-2.877,23.635-2.879A81.128,81.128,0,0,1-789.1,578.67a67.212,67.212,0,0,1,26.967,23.937q10.148,15.61,10.151,36.209,0,22.122-10.3,38.633T-791.376,702.9q-18.791,8.935-43.632,8.94Q-860.161,711.84-878.489,703.355Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.b940a03a29ef07981538794c6297e302.svg";
export { ForwardRef as ReactComponent };